import { Flex, Heading } from "@chakra-ui/react";
import React from "react";
import AddTenantActionModal from "../TenantDetails/AddTenantActionModal";
import AddTenantModal from "./AddTenantModal";

const TenantTableHeader = () => (
  <>
    <Flex justifyContent="space-between">
      <Heading mb={5}>Registered Tenants</Heading>
      <Flex gap={2}>
        <AddTenantActionModal
          defaultGlobal={true}
          buttonSize="md"
          buttonWidth="170px"
        >
          + Create Action
        </AddTenantActionModal>
        <AddTenantModal buttonSize="md" buttonWidth="170px">
          + Add Tenant
        </AddTenantModal>
      </Flex>
    </Flex>
  </>
);

export default TenantTableHeader;
